import { cx } from "@/utils";

import { useMentionCard } from "../../context";

import styles from "./PaywallNotice.module.css";

type PaywallNoticeProps = { className?: string };

const PaywallNotice: React.FunctionComponent<PaywallNoticeProps> = ({
  className,
}) => {
  const { is_paywalled } = useMentionCard();

  if (!is_paywalled) return null;
  return (
    <span
      data-testid="episode-paywalled"
      className={cx(styles.root, className)}
    >
      {L.MENTIONS_CONTEXT_PAYWALLED}
    </span>
  );
};

export default PaywallNotice;
